package com.eladfinish.bible.contest.screens.main

import com.russhwolf.settings.Settings

class ButtonListOrderRepository(
    private val settings: Settings,
) {

    fun read(): String {
        return settings.getString(key = KEY, defaultValue = "[]")
    }

    fun save(data: String) {
        settings.putString(key = KEY, value = data)
    }

    companion object {
        internal const val KEY = "main_screen_button_list_order"
    }
}
